import { cva } from 'class-variance-authority';

export const cvaItem = cva(['InfoAccordionStyles-cvaItem', 'bg-cLightGrey', 'not-last:mb-1.2', 'rounded-[1.6rem]']);

export const cvaItemHeader = cva(['InfoAccordionStyles-cvaItemHeader', 'p-3.2', 'text-bodyL', 'cursor-pointer'], {
  variants: {
    state: {
      default: [''],
      active: [''],
      notActive: [''],
    },
  },
  defaultVariants: {
    state: 'default',
  },
});

export const cvaHeaderInner = cva([
  'InfoAccordionStyles-cvaHeaderInner',
  'flex items-center justify-between gap-1.2',
  'select-none',
]);

export const cvaPlus = cva([
  'InfoAccordionStyles-cvaPlus',
  'flex items-center justify-center',
  'w-4.8 h-4.8 min-w-[4.8rem]',
  'bg-cDarkGreyOnGrey',
  'rounded-[1.6rem]',
  'stroke-cBlack',
]);

export const cvaPlusIcon = cva(['InfoAccordionStyles-cvaPlusIcon', 'w-1.6 h-1.6']);

export const cvaItemWrapper = cva(['overflow-hidden'], {
  variants: {
    right: {
      true: [''],
      false: [''],
    },
  },
});

export const cvaItemContent = cva(['InfoAccordionStyles-cvaItemContent', 'p-3.2 pt-0']);
